<template>
    <div
        class="relative"
        @mouseenter="open = true"
        @mouseleave="open = false"
    >
        <div @click="open = !open">
            <slot name="trigger" />
        </div>

        <!-- Full Screen Dropdown Overlay -->
        <!-- <div
            v-show="open"
            class="fixed inset-0 z-40"
            @click="open = false"
        /> -->

        <transition
            enter-active-class="transition duration-200 ease-out"
            enter-class="transform scale-95 opacity-0"
            enter-to-class="transform scale-100 opacity-100"
            leave-active-class="transition duration-75 ease-in"
            leave-class="transform scale-100 opacity-100"
            leave-to-class="transform scale-95 opacity-0"
        >
            <div
                v-show="open"
                class="absolute z-50 rounded-md shadow-lg"
                :class="[widthClass, alignmentClasses]"
                style="display: none"
                @click="open = false"
            >
                <div
                    class="rounded-md ring-1 ring-black ring-opacity-5"
                    :class="contentClasses"
                >
                    <slot name="content" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            align: {},
            width: {
                default: '48',
            },
            contentClasses: {
                default: () => ['py-1', 'bg-white'],
            },
        },

        data() {
            return {
                open: false,
            };
        },

        computed: {
            widthClass() {
                return {
                    48: 'w-48',
                    72: 'w-72',
                }[this.width.toString()];
            },

            alignmentClasses() {
                if (this.align === 'left') {
                    return 'origin-top-left -left-fulls';
                }
                if (this.align === 'right') {
                    return 'origin-top-right right-0';
                }
                return 'origin-top -left-full';
            },
        },

        created() {
            const closeOnEscape = (e) => {
                if (this.open && e.keyCode === 27) {
                    this.open = false;
                }
            };

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', closeOnEscape);
            });

            document.addEventListener('keydown', closeOnEscape);
        },
    };
</script>
